export default msg => +msg.replace("Network error: Response not successful: Received status code ", "")
